module.exports = __webpack_public_path__ + "img/bx-15.c8fd8ff4.jpg";